import { useState } from "react";
import { X } from "lucide-react";

const LightboxImage = ({ src, webp, alt, caption, className = "", imgClassName = "", testid = "lightbox-image", eager = false }) => {
    const [open, setOpen] = useState(false);
    return (
        <figure className={className} data-testid={testid}>
            <button type="button" onClick={() => setOpen(true)} className="block w-full cursor-zoom-in" aria-label={`Open full size: ${alt}`}>
                <picture>
                    {webp && <source srcSet={webp} type="image/webp" />}
                    <img
                        src={src}
                        alt={alt}
                        title={alt}
                        width="1600"
                        height="1000"
                        loading={eager ? "eager" : "lazy"}
                        decoding="async"
                        className={`w-full h-auto ${imgClassName}`}
                    />
                </picture>
            </button>
            {caption && <figcaption className="mt-3 text-center text-xs italic text-slate-500">{caption}</figcaption>}
            {open && (
                <div
                    className="fixed inset-0 z-[100] bg-navy/95 backdrop-blur flex items-center justify-center p-4"
                    onClick={() => setOpen(false)}
                    role="dialog"
                    aria-label="Full size image"
                    data-testid={`${testid}-overlay`}
                >
                    <button className="absolute top-5 right-5 text-white p-2" aria-label="Close">
                        <X className="w-7 h-7" />
                    </button>
                    <img src={src} alt={alt} className="max-w-full max-h-[88vh] rounded-lg shadow-2xl" />
                </div>
            )}
        </figure>
    );
};

export default LightboxImage;
